export const PLANES = {
  freemium: {
    modules: ["Submodulo de calendario", "Modulo de configuraciones", "Submodulo de horarios no disponibles"],
    limits: { sucursales: 1 },
    uniqueFeatures: [
      "Gestión completa de calendario",
      "Configuraciones personalizables",
      "Control de horarios no disponibles",
    ],
  },
  standard: {
    includes: "freemium",
    modules: ["Submodulo de clientes (CRM)", "Private Landing", "Submodulo de balance", "Submodulo de Beneficios"],
    limits: { sucursales: 1 },
    uniqueFeatures: [
      "Sistema CRM completo",
      "Landing page personalizada",
      "Control de balance financiero",
      "Sistema de beneficios para clientes",
    ],
  },
  franquicia: {
    includes: "standard",
    modules: ["Sucursales ilimitadas"],
    limits: { sucursales: Infinity },
    uniqueFeatures: [
      "Gestión de múltiples sucursales",
      "Control centralizado de todas las ubicaciones",
      "Reportes consolidados por sucursal",
    ],
  },
  enterprise: {
    includes: "franquicia",
    modules: ["Submodulo de inventarios", "Promociones", "Submodulo de cupones", "Modulo de inventarios(Proximamente)"],
    uniqueFeatures: [
      "Sistema de inventarios avanzado",
      "Motor de promociones automáticas",
      "Sistema de cupones y descuentos",
      "Analytics empresariales avanzados",
      "Soporte técnico prioritario",
    ],
  },
};

export function getPlanInfo(planName) {
  const visited = new Set();
  const modules = new Set();
  const limits = {};

  function mergePlan(plan) {
    if (!plan || visited.has(plan)) return;
    visited.add(plan);

    const config = PLANES[plan];
    if (!config) return;

    if (config.includes) {
      mergePlan(config.includes);
    }

    (config.modules || []).forEach((mod) => modules.add(mod));

    if (config.limits) {
      for (const [key, val] of Object.entries(config.limits)) {
        // Sobrescribe si es ilimitado o mejor que el actual
        if (!(key in limits) || limits[key] < val) {
          limits[key] = val;
        }
      }
    }
  }

  mergePlan(planName);

  return {
    plan: planName,
    modules: Array.from(modules),
    limits,
  };
}

export function hasModule(planName, modulo) {
  const plan = getPlanInfo(planName);
  return plan.modules.includes(modulo);
}

export function getLimit(planName, key) {
  const plan = getPlanInfo(planName);
  return plan.limits?.[key] ?? Infinity;
}

export function getUniquePlanFeatures(planName) {
  const config = PLANES[planName];
  if (!config || !config.uniqueFeatures) return [];
  return config.uniqueFeatures;
}
